// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the TryPremiumContainer */ export const TryPremiumContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-trypremium" */ "./TryPremiumContainer")).then((bundle)=>{
        return {
            default: bundle.TryPremiumContainer
        };
    });
/** Lazy-loaded TryPremiumContainer */ export const LazyTryPremiumContainer = /*#__PURE__*/ lazy(TryPremiumContainerLazyLoader);
